










    import {Component, Mixins} from "vue-property-decorator";
    import {UserProfile} from "@api/models/UserProfile";
    import ParticipantsTable from '@share/participants-table/ParticipantsTable.vue';
    import {ParticipantsDataHelper} from "@mixins/ParticipantsDataHelper";
    import Vue from 'vue';
    import {EventBus} from "@service/helpers/EventBus";
    import PeriodicRefreshMixin from "@mixins/PeriodicRefreshMixin";
    import IsParticipantsLimited from "@mixins/isParticipantsLimited";
    import { ArrayHelpers } from '@common/ArrayHelpers';
    import { DateTime } from "luxon";
    import AnalyticsMixin from "@mixins/AnalyticsMixin";
    import { ColumnFieldInterface } from "@mixins/models/ColumnFieldInterface"
    import { EventMembershipTypes } from '@api/enums/EventMembershipTypes';
    import {getFields, prepareAdditionalFields} from "@share/participants-table/helpers/FieldsHelper";
	import { TabIdEnum } from "@service/types/TabIdEnum";

    @Component({
        name: 'ParticipantsView',
        components: { ParticipantsTable }
    })
    export default class ParticipantsView extends Mixins(PeriodicRefreshMixin, AnalyticsMixin, IsParticipantsLimited) {
        static REFRESH_TIMEOUT = 60 * 1000;
        static ACTIVATE_LIMIT_TIMEOUT = 60 * 1000;

        dataHelper: ParticipantsDataHelper | null = null;
        viewMode: "default" | "table" = "default";
        fields: ColumnFieldInterface [] = [];

        get userId() {
            return this.$route.params.userId ? parseInt(this.$route.params.userId) : null;
        }

        get participantTypes() {
            return [EventMembershipTypes.participant, EventMembershipTypes.speaker];
        }

        async mounted() {
            const participants = this.$store.getters["events/selectedEventViewParam"]("participants")
            if(participants?.view === "table") {
                this.viewMode = "table"
            }

            this.fields = getFields(this.$store);

            this.$store.dispatch('showSpinner');

            await this.init();

            EventBus.$on('eventChanged', this.init);

            this.$store.dispatch('hideSpinner');

            this.initRefresh(this.refreshLoadedParticipants, ParticipantsView.REFRESH_TIMEOUT,
                () => {
                    if (!this.dataHelper) {return;}
                    this.dataHelper.page = 1;
                    this.dataHelper.list = [];
                    this.dataHelper?.fetchUsers();
                }, ParticipantsView.ACTIVATE_LIMIT_TIMEOUT);
        }

        async activated() {
            this.sendScreenView('Participants list');

            const title = this.$store.getters['services/tabTitle'](TabIdEnum.participants, this.lang) || this.$t('common.' + TabIdEnum.participants).toString();
            this.$store.dispatch("setPageTitle", title);
        }

        // Обновляет данные уже загруженных участников
        async refreshLoadedParticipants() {
            if (!this.dataHelper) {return;}

            // получим даты изменения для загруженных профилей в списке
            const updateInfo: Record<'id'|'updatedAt', string>[] = await this.dataHelper.fetchUserUpdateInfo(this.dataHelper?.list);
            const updateInfoByKeys = ArrayHelpers.keyBy(updateInfo || [], 'id');

            const updatedProfileIds: string[] = [];
            // для каждого профиля из списка сравним дату изменения с полученными датами с бекенда и сформируем массив идентификаторов
            // профилей, которые нужно загрузить с бекенда
            this.dataHelper.list.forEach(profile => {
                if (updateInfoByKeys[profile.id] && profile.updatedAt
                    && DateTime.fromISO(profile.updatedAt) < DateTime.fromISO(updateInfoByKeys[profile.id].updatedAt)) {
                    updatedProfileIds.push(profile.id);
                }
            })

            // загружаем измененные профили с бекенда и обновляем элементы списка
            if (updatedProfileIds.length > 0) {
                let updatedProfiles: UserProfile[] = await this.dataHelper.fetchUsersByIds(updatedProfileIds);
                const updatedProfilesByKeys = ArrayHelpers.keyBy(updatedProfiles || [], 'id');

                this.dataHelper.list.forEach((profile, index) => {
                    if (updatedProfilesByKeys[profile.id]) {
                        if(this.viewMode === "default") {
                            Vue.set(
                                (this.dataHelper as ParticipantsDataHelper).list,
                                index,
                                updatedProfilesByKeys[profile.id]
                            )
                        }
                    }
                })
            }
        }

        async init() {
            const groupIds: string[] = this.participantsGroupIds();

            try {
                let viewItem = new ParticipantsDataHelper(
                    this.$repositories,
                    this.$store.state.events.selected,
                    this.$store.state.session.userId,
                    groupIds,
                    this.$store
                );
                this.dataHelper = Vue.observable(viewItem);
                this.dataHelper.participantTypes = this.participantTypes;

                this.dataHelper.additionalFields = prepareAdditionalFields(this.fields);
                const firstColumnLabel = this.$t('participants.firstColumnLabel') as string;
                this.fields.splice(0, 0, { label: firstColumnLabel, fieldName: "lastName" });
                // await this.dataHelper.fetchUsers();
            }
            catch (e) {
                this.$store.dispatch('reportException', e);
            }
        }

        select(userId: number) {
            this.$router.push({
                name: 'Participant',
                params: {
                    backend: this.$route.params.backend,
                    userId: userId.toString()
                }
            });
        }

        deselect() {
            this.$router.push({
                name: 'Participants',
                params: {
                    backend: this.$route.params.backend,
                    resetScrolls: 'true'
                }
            });
        }

        destroyed() {
            EventBus.$off('eventChanged', this.init);
        }

        get lang() {
            return this.$store.state.session?.language ?? 'en'
        }
    }
